import { BBox } from "geojson";
import { InferenceCollection } from "../types/inferences";
import { convertPolygonToPointAndBbox } from "../utils";

export type GetInferencesQuery = {
  selectedDates: Date[];
  bbox: BBox | undefined;
  validated: boolean | undefined;
  asPoints: boolean | undefined
  subResource: "user" | "" | undefined;
}

type HeadersType = {
  Authorization?: string;
  "Content-Type": string;
}

export function getInferences({
  selectedDates,
  bbox,
  validated,
  asPoints = false,
  subResource = "",
}: GetInferencesQuery): Promise<InferenceCollection> {
  const headersObject:HeadersType = {
    "Content-Type": "application/json"
  };
  const token = localStorage.getItem("token");
  if (token) {
    headersObject.Authorization = `Bearer ${token}`;
  }
  const headers = new Headers(headersObject);

  const queryParams = [
    ["scene_start_date", selectedDates[0].toISOString().split("T")[0]],
    ["scene_end_date", selectedDates[1].toISOString().split("T")[0]],
  ];
  asPoints && queryParams.push(["as_points", "true"]);
  bbox && queryParams.push(["bbox", bbox.join(",")]);
  validated && queryParams.push(["validated", `${validated}`]);

  const query = new URLSearchParams(queryParams);
  return fetch(
    `${process.env.REACT_APP_API_BASE}/inferences/${subResource}?${query.toString()}`,
    { headers }
  )
    .then(r => {
      if (!r.ok) throw new Error("Unable to start get scenes.");
      return r.json();
    })
    .then(convertPolygonToPointAndBbox);
}

export function getSceneInferences(sceneId: string, validated?: boolean): Promise<InferenceCollection> {
  const headersObject:HeadersType = {
    "Content-Type": "application/json"
  };
  const token = localStorage.getItem("token");
  if (token) {
    headersObject.Authorization = `Bearer ${token}`;
  }
  const headers = new Headers(headersObject);

  const queryParams = [];
  validated !== undefined && queryParams.push(["validated", `${validated}`]);

  const query = new URLSearchParams(queryParams);
  return fetch(
    `${process.env.REACT_APP_API_BASE}/scenes/${sceneId}/inferences?${query.toString()}`,
    { headers }
  )
    .then(r => {
      if (!r.ok) throw new Error("Unable to start get scenes.");
      return r.json();
    })
    .then(convertPolygonToPointAndBbox);
}

export function invalidate(sceneId: string, inferenceId: number) {
  const token = localStorage.getItem("token");
  const headers = new Headers({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json"
  });

  return fetch(`${process.env.REACT_APP_API_BASE}/scenes/${sceneId}/inferences/${inferenceId}/validation`, {
    method: "DELETE",
    headers,
  })
    .then(r => {
      if (!r.ok) throw new Error("Unable to invalidate inference.");
      return r.json();
    });
}

export function validate(sceneId: string, inferenceId: number, isValid: boolean) {
  const token = localStorage.getItem("token");
  const headers = new Headers({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json"
  });

  return fetch(`${process.env.REACT_APP_API_BASE}/scenes/${sceneId}/inferences/${inferenceId}/validation`, {
    method: "POST",
    headers,
    body: JSON.stringify({ is_valid: isValid })
  })
    .then(r => {
      if (!r.ok) throw new Error("Unable to validate inference.");
      return r.json();
    });
}
